'use client';

// T043 — Fires SUPPORT_MAINNET_PAGE_VIEWED on mount.
//
// Embedded in the Server Component page so the page itself stays server-side.

import type { JSX } from 'react';
import { useEffect } from 'react';

import { onEvent } from '@/events';

export interface PageViewedTrackerProps {
  locale: string;
}

export function PageViewedTracker({ locale }: PageViewedTrackerProps): JSX.Element | null {
  useEffect(() => {
    onEvent('support_mainnet_page_viewed', { locale });
  }, [locale]);

  return null;
}
